import { NgModule } from '@angular/core';
import {
  ExtraOptions,
  PreloadAllModules,
  RouterModule,
  Routes
} from '@angular/router';
import { Path } from '@authority-labs/enums';
import { AuthGuardService } from './auth/authentication.guard';

const routes: Routes = [
  {
    path: Path.App,
    loadChildren: () =>
      import('./modules/landing/landing.module').then((m) => m.LandingModule),
    canLoad: [AuthGuardService]
  },
  {
    path: Path.Login,
    loadChildren: () =>
      import('./modules/login/login.module').then((m) => m.LoginModule)
  },
  { path: '**', redirectTo: '/app/orders' }
];

const routerOptions: ExtraOptions = {
  preloadingStrategy: PreloadAllModules,
  enableTracing: false,
  // scrollPositionRestoration: 'enabled',
  // anchorScrolling: 'enabled',
  // scrollOffset: [0, 64]
  relativeLinkResolution: 'legacy'
};

@NgModule({
  imports: [RouterModule.forRoot(routes, routerOptions)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
